import { useContext } from 'react';
import { AuthContext } from '../authContext/AuthContext';
export function useGetAccessToken() {
    var _a;
    var authResult = useContext(AuthContext).authResult;
    if (!authResult)
        return null;
    return (_a = authResult.accessToken) !== null && _a !== void 0 ? _a : null;
}
//# sourceMappingURL=useGetAccessToken.js.map